<footer class="footer py-4" style="background-color: #F5F4F9;">
    <div class="container">
        <div class="row text-right">


            <div class="col-md-4 ">
                  <p class="py-2 pr-3" style="color: #707070;"><strong>تواصل معنا</strong></p>
                  <p class="text-muted text-white"> +072595650763 <strong class="text-dark pl-3">رقم الجوال</strong></p>
                  <p class="text-muted text-white"> testmail2021@test.com <strong class="text-dark pl-3">البريد الالكترونية</strong></p>
              
                  <div class="d-flex">
                     
                      <p class="text-muted text-white"> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد </p>
                      <strong class="text-dark pl-3">مقرناالرئيسي</strong>
                  </div>
            </div>


            <div class="col-md-4 ">
              <p class="py-2 pr-3" style="color: #707070;" ><strong>الجريدة الالكترونية</strong></p>
              <p class="text-muted text-white">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد</p>
              <div class="input-group mb-3">
                  <div class="input-group-prepend">
                      <button class="btn input-group-text btn-lg" style="background-color: #3D0C8A;"><i class="fas fa-angle-left text-white"></i></button>
                  </div>
                  <input class="form-control text-right" type="text" placeholder="الايميل الشخصي">
              </div>
              <div class="d-flex justify-content-end">
                 <span><i class="fab fa-facebook px-2"></i></span>
                 <span><i class="fab fa-instagram px-2"></i></span>
                 <span><i class="fab fa-twitter px-2"></i></span>
                 <span><i class="fab fa-whatsapp pl-2 pr-4"></i></span>
              </div>
        </div>


        <div class="col-md-4 ">
              <img width="40%" class="img-fluid pb-2" src="https://static.rfstat.com/renderforest/images/v2/logo-homepage/gradient_3.png" alt="asdas">
              <p class="text-muted text-white"> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد</p>
             
          </div>
        </div>
        <hr>
        <p class="text-muted py-4 text-center">Copyright c 2019 All rights reserved </p>
    </div>
</footer>
